import {StyleSheet} from 'aphrodite';

// Bounds for the raw-data hover-preview, matching the flowchart popover sizing.
export const MAX_PREVIEW_HEIGHT = 500;
export const MAX_PREVIEW_WIDTH = 700;

export const popoverPreviewStyles = StyleSheet.create({
  chipPreview: {
    padding: 10,
  },
  dataFramePreview: {
    maxWidth: MAX_PREVIEW_WIDTH,
  },
  fixedHeightDataFramePreview: {
    height: MAX_PREVIEW_HEIGHT,
    maxWidth: MAX_PREVIEW_WIDTH,
  },
  /**
   * Chart and certain file previews will grow to whatever dimensions are provided, so provide fixed
   * dimensions. Center content, so loading throbbers aren't positioned awkwardly in the upper-left.
   */
  fixedDimensionPreview: {
    display: 'flex',
    justifyContent: 'center',
    height: MAX_PREVIEW_HEIGHT,
    width: MAX_PREVIEW_WIDTH,
  },
});
